import { render, staticRenderFns } from "./WotSendList.vue?vue&type=template&id=76f406b3"
import script from "./WotSendList.vue?vue&type=script&lang=js"
export * from "./WotSendList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports